import React, { useContext } from 'react'

import { ButtonV2, Icon, Row } from '@vividseats/vivid-ui-kit'

import filterContext from '@/components/pages/production/components/context'
import { SortFilterNames } from '@/components/pages/production/components/context/types'
import ticketDetailsContext from '@/components/pages/production/components/ticket-details/context'
import { trackEvent } from '@/utils/analytics/ga360'

import styles from './styles.module.scss'

const SortByButtons: React.FC = () => {
    const {
        state: filterState,
        dispatch: { onSortFilterChangeAction: onFilterChange },
    } = useContext(filterContext)
    const {
        state: detailsState,
        dispatch: { toggleDetails },
    } = useContext(ticketDetailsContext)

    return (
        <span className={styles.container}>
            <Row className={styles.buttonRow}>
                <ButtonV2
                    importance="text"
                    className={styles.sortButton}
                    data-testid="price-button"
                    onClick={() => {
                        if (detailsState.listing) {
                            toggleDetails({ listing: null })
                        }
                        trackEvent('FilterUse', 'UsedTicketFilters', 'priceasc', undefined, false)
                        onFilterChange({ name: SortFilterNames.PRICE })
                    }}
                >
                    Sort By Price
                </ButtonV2>
                <Icon
                    type="check"
                    size="md"
                    className={filterState.sortFilterState.name === SortFilterNames.PRICE ? styles.check : styles.hide}
                ></Icon>
            </Row>
            <Row className={styles.buttonRow}>
                <ButtonV2
                    importance="text"
                    className={styles.sortButton}
                    data-testid="row-button"
                    onClick={() => {
                        if (detailsState.listing) {
                            toggleDetails({ listing: null })
                        }
                        trackEvent('FilterUse', 'UsedTicketFilters', 'rowasc', undefined, false)
                        onFilterChange({ name: SortFilterNames.ROW })
                    }}
                >
                    Sort By Row
                </ButtonV2>
                <Icon
                    type="check"
                    size="md"
                    className={filterState.sortFilterState.name === SortFilterNames.ROW ? styles.check : styles.hide}
                ></Icon>
            </Row>
            <Row className={styles.buttonRow}>
                <ButtonV2
                    importance="text"
                    className={styles.sortButton}
                    data-testid="section-button"
                    onClick={() => {
                        if (detailsState.listing) {
                            toggleDetails({ listing: null })
                        }
                        trackEvent('FilterUse', 'UsedTicketFilters', 'sectionasc', undefined, false)
                        onFilterChange({ name: SortFilterNames.SECTION })
                    }}
                >
                    Sort By Section
                </ButtonV2>
                <Icon
                    type="check"
                    size="md"
                    className={
                        filterState.sortFilterState.name === SortFilterNames.SECTION ? styles.check : styles.hide
                    }
                ></Icon>
            </Row>
        </span>
    )
}

export default SortByButtons
